export const FORWARDING_RULE_ALGORITHM = {
  ROUND_ROBIN: {
    name: 'ROUND_ROBIN',
    label: 'Round Robin',
  },
  LEAST_CONNECTION: {
    name: 'LEAST_CONNECTION',
    label: 'Least Connection',
  },
  RANDOM: {
    name: 'RANDOM',
    label: 'Random',
  },
  SOURCE_IP: {
    name: 'SOURCE_IP',
    label: 'Source IP',
  },
};
